/**
 * Sticky mobile-only CTA that floats above the bottom of the screen on small viewports.
 * Hides on admin/portal routes and on the booking page itself to avoid double CTAs.
 */
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';
import { hasBookedSession } from '../lib/leadMagnetSuppression';

export default function MobileStickyCta() {
  const location = useLocation();
  const hide = /^\/(admin|portal|login|signup|client|free-jumpstart-session|free-health-jumpstart|free-life-jumpstart|schedule|book-session|challenge)/i.test(location.pathname);
  if (hide) return null;
  // Suppress once the visitor has already booked the Free Jumpstart Session.
  // Flag is set on booking-confirmation AND hydrated cross-device from the
  // backend via /api/me/lead-suppression on Layout mount.
  if (hasBookedSession('strategy_session')) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-[70] md:hidden bg-white border-t border-[#E2E8F0] shadow-[0_-2px_12px_rgba(15,23,42,0.08)]"
      data-testid="mobile-sticky-cta"
    >
      <Link
        to="/free-jumpstart-session"
        className="flex items-center justify-center gap-2 bg-[#1D4ED8] hover:bg-[#1E40AF] text-white font-bold text-sm py-3 mx-3 my-2 rounded-md transition-colors"
        data-testid="mobile-sticky-cta-link"
      >
        <Calendar size={16} />
        Book Your FREE Jumpstart Session
        <ArrowRight size={14} />
      </Link>
    </div>
  );
}
